import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ArticleLinkData, Article, ArticleService } from '../../../shared/public-api';

@Component({
  selector: 'admin-article-link-section',
  templateUrl: './article-link-section.component.html',
  styleUrls: ['./article-link-section.component.scss'],
  imports: [SelectModule, CommonModule, FormsModule],
})
export class ArticleLinkSectionComponent implements OnInit {
  @Input() sectionData: ArticleLinkData;
  @Output() sectionDataChange = new EventEmitter<any>();
  articles: Observable<Article[]>;

  constructor(private articleService: ArticleService) {}

  ngOnInit(): void {
    if (!this.sectionData) {
      this.sectionData = new ArticleLinkData();
    }

    this.articles = this.articleService.getAllArticles();
  }
}
